<div class="bigger-container">
  <div class="left-section">
    <p [ngClass]="{ selected: step === 0 }" (click)="changeTab(0)">
      Anagrafica
    </p>
    <p [ngClass]="{ selected: step === 1 }" (click)="changeTab(1)">
      Formazione
    </p>
  </div>
  <div class="right-section">
    <div class="back-button" (click)="goBack()">
      <i class="material-icons">arrow_back</i>
      <p>Torna alla lista</p>
    </div>
    <div class="smaller-container">
      <p class="smaller-text">{{ isNew ? "Crea" : "Dettagli" }} Psicologo</p>
      <div class="smaller-bar"></div>
    </div>
    <form [formGroup]="form" class="mt-5 px-3">
      <!-- -INFO -->
      <div *ngIf="step === 0" class="grid" formGroupName="info">
        <div>
          <label class="label" for="name">Nome<span class="red">*</span></label>
          <input readonly type="text" id="name" formControlName="name" />
        </div>
        <div>
          <label class="label" for="surname"
            >Cognome<span class="red">*</span></label
          >
          <input readonly type="text" id="surname" formControlName="surname" />
        </div>
        <div>
          <label class="label" for="email"
            >Email<span class="red">*</span></label
          >
          <input readonly type="text" id="email" formControlName="email" />
        </div>
        <div>
          <label class="label" for="phone"
            >Cellulare<span class="red">*</span></label
          >
          <input readonly type="text" id="phone" formControlName="phone" />
        </div>

        <div></div>

        <ng-template #elseBlock>
          <div>
            <label class="label">Foto</label>
            <p id="foto">
              Puoi aggiungere la foto nella sezione "modifica" del profilo
            </p>
          </div>
        </ng-template>

        <div *ngIf="psychologist !== undefined">
          <label class="label" for="subInterest">ID psicologo:</label>
          <p style="font-weight: bold">{{ psychologist.docRef }}</p>
        </div>
        <div>
          <label class="label" for="calendarLink">Link al calendario</label>
          <input
            readonly
            type="text"
            id="calendarLink"
            formControlName="calendarLink"
          />
        </div>

        <!-- <div style="grid-column: 1/3" class="input-field">
          <label class="label" for="description">Descrizione</label>
          <textarea
            style="grid-column: 1/3; width: 100%"
            rows="6"
            id="description"
            maxlength="426"
            formControlName="description"
          ></textarea>
        </div>
        <div style="grid-column: 1/3" class="input-field">
          <label class="label" for="note">Note</label>
          <textarea
            style="grid-column: 1/3; width: 100%"
            rows="6"
            id="note"
            maxlength="2048"
            formControlName="notes"
          ></textarea>
        </div> -->
      </div>
      <!-- *active -->
      <!-- <div
        *ngIf="step === 0"
        style="display: flex; gap: 10px; align-items: center; margin-top: 10px"
      >
        <label class="label" for="active">Profilo attivo</label>
        <input type="checkbox" id="active" formControlName="active" />
      </div> -->
      <!-- -LANGUAGES -->
      <!-- <div *ngIf="step === 1" class="grid" formGroupName="lang">
        <div>
          <label class="label" for="title">Titolo di studio</label>
          <select formControlName="title">
            <option value="Medie inferiori">Medie inferiori</option>
            <option value="Medie superiori">Medie superiori</option>
            <option value="Laurea">Laurea</option>
          </select>
        </div>
        <div
          [ngStyle]="{
            opacity: form.get('lang.title')?.value !== 'Laurea' ? '70%' : '100%'
          }"
        >
          <label class="label" for="graduationType">Tipo di laurea</label>
          <input
            type="text"
            id="graduationType"
            formControlName="graduationType"
          />
        </div>
        <div>
          <label class="label" for="english">Inglese</label>
          <select formControlName="english">
            <option value="Non lo parlo">Non lo parlo</option>
            <option value="Sufficiente">Sufficiente</option>
            <option value="Ottimo">Ottimo</option>
            <option value="Madrelingua">Madrelingua</option>
          </select>
        </div>
        <div>
          <label class="label" for="italian">Italiano</label>
          <select formControlName="italian">
            <option value="Non lo parlo">Non lo parlo</option>
            <option value="Sufficiente">Sufficiente</option>
            <option value="Ottimo">Ottimo</option>
            <option value="Madrelingua">Madrelingua</option>
          </select>
        </div>
      </div> -->
      <!-- -SPECIALITIES -->
      <div
        *ngIf="step === 1"
        style="display: flex; flex-direction: column; margin-top: 20px"
      >
        <label
          style="text-align: start; width: 100%; margin-bottom: 10px"
          class="label"
          for="specialties"
          >Specializzazioni</label
        >

        <ul>
          <li *ngIf="form.get('umore')?.value">Umore</li>
          <li *ngIf="form.get('ansia')?.value">Ansia</li>
          <li *ngIf="form.get('stress')?.value">Stress</li>
          <li *ngIf="form.get('autostima')?.value">Autostima</li>
          <li *ngIf="form.get('affettivita_e_relazioni')?.value">
            Affettività e relazioni
          </li>
          <li *ngIf="form.get('dipendenze')?.value">Dipendenze</li>
          <li *ngIf="form.get('lavoro')?.value">Lavoro</li>
          <li *ngIf="form.get('crescita_personale')?.value">
            Crescita personale
          </li>
          <li *ngIf="form.get('raggiungimento_obiettivi')?.value">
            Raggiungimento obiettivi
          </li>
          <li *ngIf="form.get('fobie')?.value">Fobie</li>
          <li *ngIf="form.get('alimentazione')?.value">Alimentazione</li>
          <li *ngIf="form.get('sessualità')?.value">Sessualità</li>
          <li *ngIf="form.get('genitorialità')?.value">Genitorialità</li>
          <li *ngIf="form.get('lutti')?.value">lutti</li>
          <li *ngIf="form.get('traumi')?.value">Traumi</li>
        </ul>
      </div>

      <app-alert
        *ngIf="showAlert"
        (save)="onAlertAction($event)"
        [data]="{ type: undefined }"
        [title]="'Attenzione, alcuni dati sono stati modificati!'"
        [message]="'Vuoi salvare le modifiche effettuate?'"
      >
      </app-alert>

      <div
        class="modal"
        id="modal-container"
        *ngIf="showModal"
        (click)="dismiss($event)"
      >
        <div class="modal-content">
          <app-image-cropper
            [imageSource]="sanitize(chosenPhoto)"
            (outputEvent)="getCroppedPhoto($event)"
          >
          </app-image-cropper>
          <div class="modal-button-container">
            <button class="secondary-button" (click)="cropperAbort()">
              Annulla
            </button>
            <button
              class="secondary-button"
              (click)="uploadImage(finalPhoto, psychologist.docRef)"
            >
              Conferma
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
